module.exports = __webpack_public_path__ + "static/Ficotex_Logo-d19215133df37acda14dfdc85e032c14.jpg";